const STRIPE_PRODUCT_ID = process.env.REACT_APP_PUBLIC_STRIPE_PRODUCT_ID;

const adminPlatformPlanLinkForm = {
	urlPOST: "billing/platform-plan-link",
	idKey: "_id",
	header: {
		create: { label: "Generate Platform Plan Link" },
	},
	content: {
		create: {
			items: [
				{
					key: "email",
					type: "text",
					label: "Email",
					required: true,
					validation: {
						email: true,
					},
				},
				{
					key: "first_name",
					type: "text",
					label: "First Name",
				},
				{
					key: "last_name",
					type: "text",
					label: "Last Name",
				},

				{
					key: "plan",
					type: "autocomplete",
					label: "Plan",
					required: true,
					autocomplete: {
						provider: "smarthop",
						url: "billing/platform-plans-main",
						preloadDefault: true,
						showDescription: true,
						params: {
							options_public_only: false,
						},
					},
				},
				{
					key: "price",
					type: "autocomplete",
					label: "Price",
					required: true,
					autocomplete: {
						provider: "smarthop",
						url: "billing/platform-plan-prices",
						preloadDefault: true,
						showDescription: true,
					},
					rules: {
						params: {
							valueRef: "plan",
							paramKey: "options_plan_ids_search",
						},
					},
				},
				{
					key: "couponCode",
					type: "text",
					label: "Coupon Code",
				},
				{
					type: "action",
					action: "SUBMIT",
					confirmation: {
						enable: true,
						message: "Are you sure you want to send a signup link with these details?",
					},
					label: "Send Signup Link",
					onSuccess: async (response, { callEndpoint }) => {
						// Create signup URL with form data and verification token
						const signupUrl = response?.signupUrl;
						// Copy to clipboard
						navigator.clipboard.writeText(signupUrl);
						console.log(signupUrl);
					},
				},
			],
		},
	},
};

export default adminPlatformPlanLinkForm;
